const getInitialState = () => ({
    viewedIntro: false,
    instructions: {
        audio: {
            src: ''
        },
        text: ''
    },
    instructionsAudio: null,
    instructionsAudios: null,
    rounds: [{ steps: [{ answer: '' }] }],
    progress: {
        roundIndex: -1,
        stepIndex: -1,
        completedSteps: []
    },
    data: {
        keyboard: {},
        activityId: '',
        rounds: {},
        showVideo: false,
        title: '',
        videos: [],
        type: '',
        category: '',
        description: '',
        productCurriculums: [],
        scheduledActivityId: undefined,
        spotCheck: false,
        activityTypeVariant: {
            videos: []
        }
    },
    isRestarting: false,
    showIntro: true,
    dataLoaded: false,
    readyToStart: false,
    showAssessmentHelpBtn: false,
    keepInstructionsOnScreen: false,
    teacherAssist: undefined,
    teacherAction: undefined,
    spotCheckRetries: 0,
    stepIndicator: 'steps'
});
export default getInitialState;
